export default __webpack_public_path__ + "static/media/oil95.debb3459.jpg";